var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Geocerca " + _vm._s(_vm.form.descripcion))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "descripcion_geocerca",
                  placeholder: "Escriba una descripción..."
                },
                model: {
                  value: _vm.form.descripcion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "descripcion", $$v)
                  },
                  expression: "form.descripcion"
                }
              },
              [_vm._v("\n          Descripción*\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimalCoordinates,
                  id: "radio",
                  placeholder: "Escriba el radio..."
                },
                model: {
                  value: _vm.form.radio,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "radio", $$v)
                  },
                  expression: "form.radio"
                }
              },
              [_vm._v("\n          Radio (en metros)*\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimalCoordinates,
                  id: "latitud",
                  placeholder: "Escriba una latitud..."
                },
                model: {
                  value: _vm.form.latitud,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "latitud", $$v)
                  },
                  expression: "form.latitud"
                }
              },
              [_vm._v("\n          Latitud\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.decimalCoordinates,
                  id: "longitud",
                  placeholder: "Escriba una longitud..."
                },
                model: {
                  value: _vm.form.longitud,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "longitud", $$v)
                  },
                  expression: "form.longitud"
                }
              },
              [_vm._v("\n          Longitud\n        ")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _c("span", [_vm._v("Aceptar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.cancelar }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40d2c3a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d2c3a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/Geocerca.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-40d2c3a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/Geocerca.vue
// module chunks = 0